<template>
  <v-layout row wrap mb-5>
    <v-flex xs12 class="text-xs-center pages-title"><h1>{{ $t('pages.rules') }}</h1></v-flex>
    <v-flex xs12 mb-5 class="text-xs-center">
      <v-progress-circular :size="50" indeterminate color="primary" v-if="ruleLoading"></v-progress-circular>
        <v-flex lg8 offset-lg2 v-for="rule in $t('rules.list')" :key="rule.title">
          <div class="rule-title">{{ rule.title }}</div>
          <div class="rule-text" v-html="rule.description"></div>
        </v-flex>
      <v-flex lg8 offset-lg2>
        <v-btn block flat class="rule-btn" :href="ruleLink" target="_blank">{{ $t('rules.download') }}</v-btn>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import PagesFunc from '@/components/pages'
export default {
  name: 'Rules',
  data () {
    return {
      ruleLoading: false,
      ruleLink: `/static/document/regulament.pdf`
    }
  },
  created () {
    PagesFunc.breadcrumbsJSON(this.$router.currentRoute.path, this.$t('pages.rules'))
  }
}
</script>

<style scoped>
.rule-btn {
  background: rgba(255,255,255,0.25) !important;
  font-family: 'Montserrat Regular',sans-serif;
  font-size: 16px;
  color: #fff !important;
  text-transform: none;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Rules.vue